import React from "react";

const QueryContext = React.createContext();

export default QueryContext